import { computed, inject } from 'vue';
import { useStore } from 'vuex';

/**
 * Returns a computed property for the quality rating text.
 * @param {number|Ref<number>} score - The quality rating score.
 * @param {object|string|Ref<object|string>} qualityRatingTextOverride - Optional. If included will override the quality rating text.
 * @returns <string>
 */
export default function useQualityRating(score, qualityRatingTextOverride = null) {
  const store = useStore();

  const $bct = inject('translator');

  const qualityRatingText = computed(() => {
    // Check for override first
    if (qualityRatingTextOverride !== null) {
      const overrideValue =
        typeof qualityRatingTextOverride === 'object' &&
        qualityRatingTextOverride?.value !== undefined
          ? qualityRatingTextOverride.value
          : qualityRatingTextOverride;

      if (typeof overrideValue === 'string' && overrideValue.trim().length > 0) {
        return overrideValue;
      }
    }

    const value = typeof score === 'object' && score?.value !== undefined ? score.value : score;
    if (!value) return '';
    if (!store.state.site.ratings?.text) return value.toString();

    const ratingIndex = value - 1;
    const ratingTextMetadata = store.state.site.ratings.text[ratingIndex];

    if (!ratingTextMetadata) return value.toString();

    let text = $bct(ratingTextMetadata.title);
    if (ratingTextMetadata.subtitle) text += ` - ` + $bct(ratingTextMetadata.subtitle);

    return text;
  });

  return qualityRatingText;
}
